import { GestionAfiliado } from './GestionAfiliado';

export class GestionAfiliado_Parametro {
    nroDocumento: string;
    nombres: string;
    tituloEstado: string;
    motivo: string;
    descripcionMotivo: string;
    gestionAfiliado_Seleccionado: GestionAfiliado[];
    gestionAfiliado_ListaConsulta: GestionAfiliado[];
    tipoRetorno: string;
    parametroAdicionalTipoRetorno: string;
    consultarDatos: boolean;
}